var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home hardlist-home"},[_c('HardwareLayout',{attrs:{"layoutType":"HARDLIST","layoutTitile":"节点提交"}},[_c('Tips',{staticClass:"withdrawal-tips",attrs:{"title":"标准节点提交注意事项","tips":_vm.$t('tips')}}),_c('Node')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }